(function () {

  function getRepName() {
    var infoIdp = JSON.parse(ux.utils.cookie.get('info_idp') || null);
    if (infoIdp) {
      return infoIdp.firstname;
    }

    var fullName = $('.shopper-name').html();
    return fullName ? fullName.split(' ')[0] : '';

  }

  function generateTrafficEvent(pageType) {
    if (ux.traffic && ux.traffic.custom) {
      var eventName = 'mcx.help.' + pageType + '.email';
      ux.traffic.custom('vault', eventName, [
        ['url', window.location.href],
        ['plId', requestContext.plId]
      ]);
    }
  }

  function verifyCustomerNumber(customerNumber, callback) {
    $.ajax({
      type: 'POST',
      url: requestContext.hostPath + '/ajax/verifyShopper',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({ shopperId: customerNumber })
    })
      .complete(function (resp) {
        callback(null, resp);
      });
  }

  function sendEmail(emailMsg, pageType, callback) {

    emailMsg.repName = getRepName();
    emailMsg.deptName = '';

    $.ajax({
      type: 'POST',
      url: requestContext.hostPath + '/ajax/emailPageContent',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(emailMsg)
    })
      .complete(function (resp) {
        if (resp.status === 200) {
          generateTrafficEvent(pageType);
        }
        callback(null, resp);
      });
  }

  $('body').bind('ajaxSend', function (elm, xhr, s) {
    if (s.type === 'POST') {
      var csrfToken = $('#_csrf').val();
      if (csrfToken) {
        xhr.setRequestHeader('X-CSRF-Token', csrfToken);
      }
    }
  });


  window.gdvault = window.gdvault || {};
  window.gdvault.sendEmail = sendEmail;
  window.gdvault.verifyCustomerNumber = verifyCustomerNumber;

}());
